import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'account.downloads.title',
    defaultMessage: 'Product downloads',
  },
  filterProducts: {
    id: 'account.downloads.filter',
    defaultMessage: 'Filter products',
  },
  download: {
    id: 'account.downloads.download',
    defaultMessage: 'Download',
  },
  os: {
    id: 'account.downloads.os',
    defaultMessage: 'Operating system',
  },
  error: {
    id: 'account.downloads.error',
    defaultMessage: 'Something went wrong',
  },
  back: {
    id: 'account.downloads.back',
    defaultMessage: 'Back to all products',
  },
  latestVersion: {
    id: 'account.downloads.latest',
    defaultMessage: ' Latest version',
  },
  previousVersions: {
    id: 'account.downloads.previous',
    defaultMessage: 'Previous versions',
  },
  mobileAccess: {
    id: 'account.downloads.mobile',
    defaultMessage:
      'To access your product downloads, visit My Account on a desktop device',
  },
});
